import { Typography } from "@mui/material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useGetLatestOrderQuery } from "src/api/services/ordersApi";
import WhiteCard from "src/shared/components/WhiteCard";
import Medication from "../Medication";
import { PatientSubscriptionWithOrder } from "src/api/types";

interface Props {
  subscription: PatientSubscriptionWithOrder;
}

const MedInstructionsCard = ({ subscription }: Props) => {
  const { data } = useGetLatestOrderQuery({
    productId: subscription.product_id,
  });
  const { t } = useTranslation();
  const component = "care.treatmentPlanCard";

  const order = useMemo(() => {
    if (data == null) return;

    return data;
  }, [data]);

  const details = useMemo(() => {
    return order?.details;
  }, [order?.details]);

  const category = useMemo(() => {
    return order?.product_category.name ?? "";
  }, [order?.product_category.name]);

  const numberOfMonths = useMemo(() => {
    return subscription?.price.number_of_months ?? 0;
  }, [subscription?.price.number_of_months]);

  return order != null ? (
    <WhiteCard>
      <Typography variant="h6" fontWeight={600}>
        {t(`${component}.howToTake.header`, "How to take")}
      </Typography>
      {details?.instructions.map((detail, idx) => (
        <Medication
          key={`${detail.id}-${idx}`}
          detail={details}
          index={idx}
          component={component}
          category={category}
          numberOfMonths={numberOfMonths}
        />
      ))}
    </WhiteCard>
  ) : null;
};

export default MedInstructionsCard;
